export default __webpack_public_path__ + "static/media/gift.6c7f4498.png";